<template>
  <el-select
    filterable
    clearable
    placeholder="请选择"
    v-model="currentValue"
    size="small"
    @change="handleChange"
  >
    <el-option
      :key="item"
      :label="item"
      :value="item"
      v-for="item in options"
    >
    </el-option>
  </el-select>
</template>

<script>
  export default {
    name: "SearchUserId",
    props: ['value'],
    data() {
      return {
        currentValue: this.value,
        options: [],
      }
    },
    mounted() {
      this.getList()
    },
    watch: {
      value(newVal) {
        this.currentValue = newVal;
      }
    },
    methods: {
      getList(){
        this.$http.get('customer/customerIdList')
            .then(({data}) => {
              if (data.code === 200) {
                this.options = data.data || []
              }
            })
      },
      handleChange(value){
        this.$emit('input', value);
        // this.$emit('zclChangeUserId',value)
      },
    }
  }
</script>

<style scoped>

</style>
